(() => {
  'use strict';
  const section = document.getElementById('cinnamon-insulin-offer');
  if (!section) return;
  const es = document.documentElement.lang.startsWith('es');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      document.documentElement.classList.toggle('cinnamon-insulin-offer-visible', entries[0].isIntersecting);
    }).observe(section);
  }
  document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && url.pathname.replace(/^\/es(?=\/)/, '').replace(/\/$/, '') === '/products/cinnamon-softgels-ceylon') {
      link.setAttribute('href', '#cinnamon-insulin-offer');
    }
  });
  function init() {
    const host = section.querySelector('.cinnamon-native-offers');
    const details = section.querySelector('#cinnamon-insulin-refill-details');
    let catalog;
    try { catalog = JSON.parse(document.getElementById('cinnamon-native-catalog').textContent); } catch (_) { return; }
    const refill = catalog.products['cinnamon-paid-pack-refills'];
    const money = amount => new Intl.NumberFormat(es ? 'es-US' : 'en-US', { style: 'currency', currency: catalog.currency || 'USD' }).format(amount / 100);
    function update() {
      const bars = Array.from(host.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar')).filter(bar => bar.querySelector('.kaching-bundles__bar-title')).slice(0, 3);
      const index = bars.findIndex(bar => bar.getAttribute('aria-pressed') === 'true');
      const variant = refill?.product?.variants[index];
      const allocation = variant && refill.allocations[String(variant.id)]?.[0];
      if (index < 0 || !allocation) return;
      const initial = [1, 3, 5][index], recurring = [1, 2, 3][index];
      details.textContent = es ? `Primer envío: ${initial} ${initial === 1 ? 'paquete' : 'paquetes'}. Después: ${recurring} ${recurring === 1 ? 'paquete' : 'paquetes'} cada 30 días por ${money(allocation.price)}. Los paquetes gratis y el e-book son solo para el primer pedido. Envío según las condiciones mostradas al finalizar la compra.` : `First shipment: ${initial} ${initial === 1 ? "pack" : "packs"}. Then: ${recurring} ${recurring === 1 ? "pack" : "packs"} every 30 days for ${money(allocation.price)}. Free packs and the ebook are included with your first order only. Shipping follows the terms shown at checkout.`;
    }
    update();
    new MutationObserver(update).observe(host, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'], childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
